<template>
    <div class="trustpilot-stars">
        <div class="trustpilot-stars__rating">
            {{ stars }}
        </div>

        <div class="trustpilot-stars__stars">
            <div
                v-for="i in 5"
                :key="i"
                class="trustpilot-stars__star"
            >
                <!-- Show full star -->
                <svg
                    v-if="i <= stars"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 18"
                    width="16"
                    height="16"
                >
                    <rect
                        class="trustpilot-stars__star-inner"
                        x="1"
                        y="1"
                        width="16"
                        height="16"
                        fill="rgba(255, 255, 255, 0)"
                    />
                    <path
                        fill="#06ae7c"
                        d="M0,0v18h18V0H0z M11.74,11.45l1.15,3.54l-3.87-2.82l-0.03,0.02l-3.91,2.82l1.49-4.58L2.66,7.58H7.5L8.99,3l1.49,4.58h4.83l-3.91,2.85l-2.38,1.74L11.74,11.45z"
                    />
                </svg>

                <!-- Show partially filled star -->
                <svg
                    v-else-if="Math.ceil(stars) === i && stars % 1 > 0"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 18"
                    width="16"
                    height="16"
                >
                    <rect
                        class="trustpilot-stars__star-inner"
                        x="1"
                        y="1"
                        width="16"
                        height="16"
                        fill="rgba(255, 255, 255, 0)"
                    />
                    <path
                        fill="#d5d5d4"
                        d="M0,0v18h18V0H0z M11.74,11.45l1.15,3.54l-3.87-2.82l-0.03,0.02l-3.91,2.82l1.49-4.58L2.66,7.58H7.5L8.99,3l1.49,4.58h4.83l-3.91,2.85l-2.38,1.74L11.74,11.45z"
                    />
                    <path
                        :style="{'clip-path': getClipPath}"
                        fill="#06ae7c"
                        d="M0,0v18h18V0H0z M11.74,11.45l1.15,3.54l-3.87-2.82l-0.03,0.02l-3.91,2.82l1.49-4.58L2.66,7.58H7.5L8.99,3l1.49,4.58h4.83l-3.91,2.85l-2.38,1.74L11.74,11.45z"
                    />
                </svg>

                <!-- Show empty star -->
                <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 18"
                    width="16"
                    height="16"
                >
                    <rect
                        class="trustpilot-stars__star-inner"
                        x="1"
                        y="1"
                        width="16"
                        height="16"
                        fill="rgba(255, 255, 255, 0)"
                    />
                    <path
                        fill="#d5d5d4"
                        d="M0,0v18h18V0H0z M11.74,11.45l1.15,3.54l-3.87-2.82l-0.03,0.02l-3.91,2.82l1.49-4.58L2.66,7.58H7.5L8.99,3l1.49,4.58h4.83l-3.91,2.85l-2.38,1.74L11.74,11.45z"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    stars: {
        type: Number,
        required: true,
        default: 5,
    },
});

const getClipPath = computed(() => {
    const percentage = props.stars % 1 * 100 + '%';
    return `polygon(0 0, ${percentage} 0, ${percentage} 100%, 0 100%)`;
});
</script>

<style lang="scss">
@use "watson-atom-variation-trustpilot";
</style>
